<template>
  <div>
    <PotensiDetail></PotensiDetail>
  </div>
</template>

<script>
import PotensiDetail from "@/components/public-potensi-detail/PotensiDetail";
export default {
  name: "PotensiDetailView",
  components: {
    PotensiDetail,
  },
};
</script>

<style scoped>
</style>